var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutAdvanced3DMain = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 29,
  height: 18,
  viewBox: "0 0 29 18",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 27,
  height: 16.2,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 7.714h9V14.2a2 2 0 0 1-2 2h-7zM0 7.714h9.257V16.2H2a2 2 0 0 1-2-2V7.714Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#263A71",
  d: "M25 0H2a2 2 0 0 0-2 2v6.486h27V2a2 2 0 0 0-2-2Z"
}))));
export { SvgLayoutAdvanced3DMain as ReactComponent };
export default __webpack_public_path__ + "assets/images/layout-advanced-3d-main.svg";